var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMarkupDrag = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 8,
    viewBox: "0 0 20 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_13146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 1.33333C16.6666 2.06971 17.2635 2.66667 17.9999 2.66667C18.7363 2.66667 19.3333 2.06971 19.3333 1.33333C19.3333 0.596954 18.7363 0 17.9999 0C17.2635 0 16.6666 0.596954 16.6666 1.33333Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 6.66665C16.6666 7.40303 17.2635 7.99998 17.9999 7.99998C18.7363 7.99998 19.3333 7.40303 19.3333 6.66665C19.3333 5.93027 18.7363 5.33331 17.9999 5.33331C17.2635 5.33331 16.6666 5.93027 16.6666 6.66665Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 1.33333C11.3332 2.06971 11.9302 2.66667 12.6665 2.66667C13.4029 2.66667 13.9999 2.06971 13.9999 1.33333C13.9999 0.596954 13.4029 0 12.6665 0C11.9302 0 11.3332 0.596954 11.3332 1.33333Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 6.66665C11.3332 7.40303 11.9302 7.99998 12.6665 7.99998C13.4029 7.99998 13.9999 7.40303 13.9999 6.66665C13.9999 5.93027 13.4029 5.33331 12.6665 5.33331C11.9302 5.33331 11.3332 5.93027 11.3332 6.66665Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 1.33333C5.99996 2.06971 6.59691 2.66667 7.33329 2.66667C8.06967 2.66667 8.66663 2.06971 8.66663 1.33333C8.66663 0.596954 8.06967 0 7.33329 0C6.59691 0 5.99996 0.596954 5.99996 1.33333Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 6.66665C5.99996 7.40303 6.59691 7.99998 7.33329 7.99998C8.06967 7.99998 8.66663 7.40303 8.66663 6.66665C8.66663 5.93027 8.06967 5.33331 7.33329 5.33331C6.59691 5.33331 5.99996 5.93027 5.99996 6.66665Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666585 1.33333C0.666585 2.06971 1.26354 2.66667 1.99992 2.66667C2.7363 2.66667 3.33325 2.06971 3.33325 1.33333C3.33325 0.596954 2.7363 0 1.99992 0C1.26354 0 0.666585 0.596954 0.666585 1.33333Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666585 6.66665C0.666585 7.40303 1.26354 7.99998 1.99992 7.99998C2.7363 7.99998 3.33325 7.40303 3.33325 6.66665C3.33325 5.93027 2.7363 5.33331 1.99992 5.33331C1.26354 5.33331 0.666585 5.93027 0.666585 6.66665Z",
    fill: "#363437"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_13146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 8,
    fill: "white",
    transform: "translate(0.666626)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarkupDrag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/markup-drag.e50d8714.svg";
export { ForwardRef as ReactComponent };